import { render, staticRenderFns } from "./CustomErrorModal.vue?vue&type=template&id=3bccb2c2"
import script from "./CustomErrorModal.vue?vue&type=script&lang=js"
export * from "./CustomErrorModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports